import { useCallback } from 'react';
import logo from 'assets/img/osb-logo.svg';
import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import MicrosoftButton from 'components/MicrosoftButton';
import Spinner from 'components/Spinner';
const VITE_AUTH_SCOPES: string[] = ((import.meta.env.VITE_AUTH_SCOPES || '') as string).split(' ');

function LoginPage() {
  const { instance, inProgress } = useMsal();

  const loginFunction = useCallback(() => {
    void (async () => {
      try {
        await instance.loginPopup({
          scopes: [...VITE_AUTH_SCOPES],
        });
      } catch (error) {
        console.log('Login failed', error);
      }
    })();
  }, [instance]);

  return (
    <div className="mx-auto flex min-h-screen items-center justify-center">
      <div className="flex max-w-lg flex-col items-center justify-center p-3">
        <img className="w-[160px] pb-5" src={logo} />
        <h1 className="mb-10 text-4xl font-semibold">Tolling Platform</h1>

        <MicrosoftButton className="mt-10 w-full" onClick={loginFunction}>
          {inProgress === InteractionStatus.None ? 'Log in with Microsoft' : <Spinner className="w-5" />}
        </MicrosoftButton>
      </div>
    </div>
  );
}

export default LoginPage;
